module.exports = __webpack_public_path__ + "static/img/liucheng.0524dac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/seo/liucheng.png
// module id = kgIt
// module chunks = 69